import AppSettings from './App.config.json'
import { AppConfig, ElectricalCode } from './Types'
import { toBoolean, retrieveParamByName } from './Utils'

const appConfig: AppConfig = AppSettings
const environment = process.env.NODE_ENV

export const isDebug: boolean = (environment === 'development' || environment === 'test') ? true : toBoolean(appConfig.isDebug)
export const build: string = appConfig.build
export const commitID: string = appConfig.commitID
export const environmentName: string = (environment === 'development') ? environment : appConfig.environmentName
export const canSelectFault: boolean = (environment === 'development') ? true : toBoolean(appConfig.CanSelectFault)
export const helpURL: string = appConfig.helpURL
export const defaultElectricalCode: ElectricalCode = appConfig.electricalCode[environment] as ElectricalCode
export const solverURI: string = appConfig.solver[environment].URI
export const xAPIURL: string = appConfig.XAPI[environment].learningEngineURL
const rxdURL: string = appConfig.RXD[environment].rootURL

export const lmsRequired: boolean = toBoolean(appConfig.RXD[environment].LMSRequired.toLowerCase())

const rxdScripts = {
    jquery: rxdURL + 'jquery.js',
    configuration: rxdURL + 'configuration.js',
    lzstring: rxdURL + 'lz-string.min.js',
    minify: rxdURL + 'minify.json.js',
    utilityFuncs: rxdURL + 'UtilityFunctions.js',
    scormDriver: rxdURL + 'SCORMDriverXD_CS.js'
}

const bodyTag = document.getElementsByTagName('head')[0]

export const loadScripts = () => getLibrary(rxdScripts.configuration)
    .then(() => Promise.all([
        getLibrary(rxdScripts.jquery),
        getLibrary(rxdScripts.lzstring),
        getLibrary(rxdScripts.minify),
    ]))
    .then(() => getLibrary(rxdScripts.utilityFuncs))
    .then(() => getLibrary(rxdScripts.scormDriver))
    .catch(error => { throw new Error(`Unable to load RXD script files. ${error}`) })

const getLibrary = (url: string) => new Promise((resolve, reject) => {
    const scriptHTML = document.createElement('script')

    scriptHTML.type = 'text/javascript'
    scriptHTML.async = true
    scriptHTML.src = url

    scriptHTML.onload = function() {
        resolve(url)
    }
    scriptHTML.onerror = function() {
        reject('error')
    }

    bodyTag.appendChild(scriptHTML)
})


export const getElectricalCode = (): ElectricalCode => {
    try {
        const ecParam = retrieveParamByName('ec', window.parent.location.href)?.toUpperCase()
        if (ecParam === ElectricalCode.IEC || ecParam === ElectricalCode.NEC) {
            isDebug && console.log('Found Electrical Code in URL:', ecParam)
            return ecParam
        }
        throw new Error(`Electrical Code not found in URL.`)

    }
    catch (error) {
        if (defaultElectricalCode !== ElectricalCode.IEC && defaultElectricalCode !== ElectricalCode.NEC)
            throw new Error(`Invalid electrical code in App.config: ${defaultElectricalCode}`)

        isDebug && console.warn(`${error} - Setting EC to configuration default of ${defaultElectricalCode}.`)
        return defaultElectricalCode
    }

}

export const getElectricalCodeName = (code: ElectricalCode): string => {
    switch (code) {
        case ElectricalCode.NEC: return 'North American'
        case ElectricalCode.IEC: return 'International'
        default: return ''
    }
}